import { render, staticRenderFns } from "./RoleCards.vue?vue&type=template&id=27fe7bb8&scoped=true&"
import script from "./RoleCards.vue?vue&type=script&lang=js&"
export * from "./RoleCards.vue?vue&type=script&lang=js&"
import style0 from "./RoleCards.vue?vue&type=style&index=0&id=27fe7bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe7bb8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fe7bb8')) {
      api.createRecord('27fe7bb8', component.options)
    } else {
      api.reload('27fe7bb8', component.options)
    }
    module.hot.accept("./RoleCards.vue?vue&type=template&id=27fe7bb8&scoped=true&", function () {
      api.rerender('27fe7bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/role/RoleCards.vue"
export default component.exports